import { consulting_cn } from './consulting'
import { detailsAboutSlide_cn } from './detailsAboutSlide'
import { footerFormCN } from './footerForm'
import { for_farmers_cn } from './forFarmers'
import { labs_cn } from './labs'
import { products_cn } from './products'
import { cn_testing } from './testing'
import { trading_cn } from './trading'

const cn = {
    search: '搜索',
    aboutUs: 'О нас',
    aboutCompany: '关于公司',
    Technologies: 'Технологии',
    news: '新闻',
    production: '产品',
    catalog: '目录',
    labs: 'Лабораторные исследования',
    contacts: '联系方式',
    productions: '生产',
    productionLower: '生产',
    partners: '合作伙伴',
    megakorm: 'Megakorm',
    megamix: 'Megamix',
    details: '更多细节',
    farmers: '农民',
    laboratories: '实验室',
    vacancy: '职位空缺',
    megamixForFarmers: 'Megamix 为农民',
    productsIngredientsAdditivesAndFeedSolutions: '产品：成分、添加剂和饲料解决方案',
    products: '产品',
    consulting: '咨询',
    laboratoriesP: '个人账户',
    trading: '贸易',
    export: '出口',
    clients: '客户',
    weFeedThoseWhoFeedUs: '我们喂养那些喂养我们的人',
    weFeedThoseWhoFeedUs1: '喂养我们的人',
    ecosystemOfMEGAMIXGROUP:
        'Megamix集团生态系统 - 主要生产各种农业动物和鸟类的预混合饲料、复合饲料及蛋白质-维生素-矿物质添加剂的制造商',
    learnMore: '了解更多',
    aboutCompany: '关于公司',
    aboutCompanyLower: '关于公司',
    forCustomers: '客户',
    customOrder: '定制订单',
    customOrderText:
        '我们是预混合饲料生产和国内市场成分供应的领导者。对于大型客户，Megamix公司愿意根据客户现有的原料基础，提供个性化配方的订单。我们公司的优势之一是拥有自己的科研和技术基础，这使得我们能够进行准确的计算和实现各种任务，以及广泛的物流能力。',
    customOrderText1:
        'Megamix集团的生产点和成分储存设施符合国际标准，保证所生产产品的高质量。要进行个性化订单，请填写反馈表或拨打我们的电话与我们联系。',
    sendEnquiry: '发送申请',
    eventsTitle: '事件日历',
    upcomingEvents: '即将举办的活动',
    featuringMegamix: '有Megamix参与',
    newsTitle: '新闻',
    usefulMaterialsTitle: '有用的材料',
    Feedback: '反馈',
    distributors: '分销商',
    footerText: '我们在俄罗斯及周边国家有超过200个分销商。您可以在我们主要产品线的网站上找到合适的分销商。',
    onMegakorm: '在Megakorm网站上',
    weAreInTouch: '我们在周一至周五的9:00至17:00之间保持联系。您可以',
    orderACall: '请求回电',
    WeAreReadyToAcceptYourRequestByMail: '我们准备通过邮件接受您的请求',
    DownloadPressKit: '下载新闻资料包，18MB',
    PressService: '新闻服务',
    FeedbackText: '确定订单或需要更多信息？请通过填写反馈表与我们联系，以获取所有必要的咨询和快速订单支持。',
    send: '发送',
    megamixB2B: 'Megamix B2B',
    LegalInformation: '法律信息',
    PersonalDataProcessing: '个人数据处理政策',
    MegamixGroup: 'Megamix集团',
    BackToMap: '返回地图',
    b2bText1: 'Megamix集团结合了在预混合饲料、饲料添加剂、BVMK和复合饲料生产领域的可靠性、创新和专业性。',
    b2bText2:
        '我们的客户不仅仅是企业，而是合作伙伴，包括大型农业控股公司和中型企业，无论是在俄罗斯还是海外。我们为我们的产品和解决方案使我们的合作伙伴在生产和效率上达到新的高度而感到自豪。',
    MegamixToday: '今天的Megamix',
    bestInRussia: '俄罗斯第一',
    bestInRussiaAbout: '俄罗斯最大的预混合饲料生产商之一，也是欧洲最大的生产商之一',
    productionsCount: '6个生产设施',
    productionsCountAbout: '6个按照国际标准运营的生产基地',
    percentInRussia: '32% 的俄罗斯市场',
    percentInRussiaAbout: '32% 的俄罗斯复合饲料是基于Megamix的预混合饲料',
    percentGlobal: '全球市场的1% ',
    percentGlobalAbout: '全球动物饲料市场的 1%',
    WorldsFirstVitE60: '全球首个干燥的E 60%',
    WorldsFirstVitE60About: '全球首个干燥饲料维生素E 60% 的制造商',
    LaboratoriesCount: '3个实验室',
    LaboratoriesCountAbout: '3个认证的科学实验室',
    OfficesCount: '7个办公室',
    OfficesCountAbout: '在俄罗斯主要城市的7个办公室',
    gmpPlus: 'GMP+',
    gmpPlusAbout: '俄罗斯第一家获得GMP+认证的预混合饲料公司',
    megamixGroupb2bCardText:
        'Megamix集团是两个现代化预混合饲料厂、两个饲料厂和CHUVA农业控股公司的联合体。这为我们的合作伙伴提供了广泛的产品和服务，涵盖农业生产的各个方面。',
    ExpertSupportTitle: '专家支持',
    ExpertSupportText:
        '持续的研究与开发：我们的研发部门不断致力于改善我们的产品种类和质量。我们利用先进的技术和知识，为客户提供满足其需求的创新解决方案。',
    HighQualityTitle: '高品质',
    HighQualityText:
        '原材料和成品的全追溯系统是Megamix集团的关键优势之一。公司保证产品混合的准确性为1:100,000，确保最终产品的高质量。',
    EfficientLogisticsTitle: '高效物流',
    EfficientLogisticsText:
        '我们自己的物流综合体确保及时向合作伙伴交付产品。这使得我们能够优化交付过程，最小化延误风险，这对我们的合作伙伴来说是一个重要因素。',
    ContinuousRDTitle: '持续的研究与开发',
    ContinuousRDText:
        '高效物流：我们自己的物流综合体确保及时向合作伙伴交付产品。这使得我们能够优化交付过程，最小化延误风险，这对我们的合作伙伴来说是一个重要因素。',
    ReliabilityAndStabilityTitle: '可靠性与稳定性',
    ReliabilityAndStabilityText:
        'Megamix集团是一个可靠且稳定的合作伙伴，愿意在任何条件下支持您的业务。我们致力于建立基于相互信任和互利合作的长期关系。',
    LargePortfolioTitle: '广泛的产品种类和高生产能力',
    LargePortfolioText:
        'Megamix饲料公司拥有巨大的生产能力，能够满足任何养殖综合体或禽场的需求。我们位于利佩茨克地区的工厂每年生产高达180,000吨，相当于每小时900袋。',
    history: '历史',
    History: '历史',
    mission: '使命',
    Mission: '使命',
    strategy: '战略',
    Strategy: '战略',
    video: '视频',
    Video: '视频',
    gallery: '画廊',
    Gallery: '画廊',
    toWebsiteButton: '访问网站',
    Megaschool: 'Megaschool',
    watch_on_Youtube: '上观看',
    Megakorm_website: '访问Megakorm网站',
    catalogSwiperCircle: '目录 目录 目录 目录 目录',
    materialsSwiperCircle: '材料 材料 材料',
    searchErrorMessage: '未找到该请求的任何内容。',
    loadingProcess: '加载中...',
    loadMore: '加载更多',
    watchAll: '查看全部',
    resetAll: '重置全部',
    specializations: '专业化',
    allSpecializations: '所有专业化',
    search: '搜索',
    photoReport: '照片报告',
    videoReport: '视频报告',
    otherNews: '其他新闻',
    readAll: '阅读全部',
    moreDetailedTest: '更多详细信息',
    externalLinks: '外部链接',
    BackToCatalog: '返回目录',
    PurposeOfProduct: '用途',
    ProductComposition: '成分',
    ProductApplication: '应用',
    Vacancies: '职位空缺',
    release: '发布',
    cookie: '使用我们的网站，即表示您同意我们使用 ',
    ok: '好的',
    agree: '同意',
    agree1: '我同意处理个人数据，并同意 ',
    agree2: '个人数据处理和保护政策的条款',
    office: '办事处',
    ...footerFormCN,
    ...for_farmers_cn,
    ...labs_cn,
    ...detailsAboutSlide_cn,
    ...consulting_cn,
    ...products_cn,
    ...trading_cn,
    ...cn_testing
}

export default cn
